import React from 'react';

import PropTypes from 'prop-types';
import { Checkbox } from 'semantic-ui-react';

import _get from 'lodash/get';

import { ActionSettingsPropType } from '../../AccountSettings.types';

const propTypes = {
  actionSettings: ActionSettingsPropType.isRequired,
  onChange: PropTypes.func.isRequired,
};

const defaultProps = {};

export default function GenericEnableSettings({ actionSettings, onChange }) {
  const enabled = _get(actionSettings, 'settings.enabled');

  return (
    <Checkbox
      toggle
      checked={enabled}
      onChange={(_, { checked }) => onChange({ enabled: checked })}
    />
  );
}

GenericEnableSettings.propTypes = propTypes;
GenericEnableSettings.defaultProps = defaultProps;
